import { render, staticRenderFns } from "./DashboardViewSection.vue?vue&type=template&id=b5597fba&scoped=true&"
import script from "./DashboardViewSection.ts?vue&type=script&lang=ts&"
export * from "./DashboardViewSection.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardViewSection.scss?vue&type=style&index=0&id=b5597fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5597fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
